module.exports = __webpack_public_path__ + "615cb43036d280038d2f2e17fe429f14.webp";